import Text14 from './Text14'
export default Text14
